"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dimensions = void 0;

/**
 * Export `dimensions`.
 */
var dimensions = {
  borderRadius: 6,
  snackbar: {
    maxWidth: 480
  }
};
exports.dimensions = dimensions;